import {Link, type LinkProps} from '@smart/react-components';
import * as React from 'react';

export function MarkdownLink({children, ...props}: LinkProps): JSX.Element {
  return (
    <Link target="_blank" variant="hyp-100" inline {...props}>
      {children}
    </Link>
  );
}
